import { Pill } from '@baseV2'
import { TENDERBOOK_FOLLOW_UP_STATUS, TENDERBOOK_FOLLOW_UP_STATUS_OPTIONS } from '@constants'

// Follow-up status → v2 Pill colour.
const FOLLOW_UP_COLOR = {
	[TENDERBOOK_FOLLOW_UP_STATUS.DONT_FOLLOW_UP]: 'neutral',
	[TENDERBOOK_FOLLOW_UP_STATUS.COLD]: 'info',
	[TENDERBOOK_FOLLOW_UP_STATUS.WARM]: 'warning',
	[TENDERBOOK_FOLLOW_UP_STATUS.HOT]: 'error',
}

const FOLLOW_UP_LABEL = Object.fromEntries(TENDERBOOK_FOLLOW_UP_STATUS_OPTIONS.map(({ id, label }) => [id, label]))

// Table cell renderer for `follow_up_status`; shows a dash when unset.
const FollowUpStatusPill = ({ status }) => {
	if (!status) return '-'
	return (
		<Pill color={FOLLOW_UP_COLOR[status] ?? 'neutral'} size='small'>
			{FOLLOW_UP_LABEL[status] ?? status}
		</Pill>
	)
}

export default FollowUpStatusPill
